import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { TreeNode } from '@shared/components/tree-select/Domain/treeNode.model';
import { TreeSelectNodeComponent } from '@shared/components/tree-select/Component/tree-select-node/tree-select-node.component';
import { NgClass, NgForOf, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SelectionMode } from '@shared/components/tree-select/Domain/selectionMode.enum';
import { TreeSelectFacade } from '@shared/components/tree-select/Application/treeSelect.facade';

@Component({
  selector: 'app-tree-select',
  standalone: true,
  imports: [TreeSelectNodeComponent, NgForOf, NgIf, NgClass, FormsModule],
  templateUrl: './tree-select.component.html',
  styleUrl: './tree-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TreeSelectComponent implements OnInit {
  @Input() nodes: TreeNode[] = [];
  @Input() placeholder = 'Select item';
  @Input() selectionMode: SelectionMode = SelectionMode.SINGLE;
  @Input() enableSearch = false;
  @Input() enableReset = false;
  @Input() selectedKeys: string[] = [];

  @Output() selectionChange = new EventEmitter<TreeNode[]>();

  constructor(
    private readonly elementRef: ElementRef,
    public readonly facade: TreeSelectFacade,
  ) {}

  ngOnInit(): void {
    this.facade.initialize(this.nodes, this.selectedKeys);
  }

  get displayLabel(): string {
    const selected = this.facade.selectedNodes();
    const count = selected.length;
    if (count === 0) return '';
    if (count <= 2) return selected.map((n) => n.label).join(', ');
    return `Campañas + ${count}`;
  }

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.facade.isOpen.set(false);
    }
  }

  toggleDropdown() {
    this.facade.toggleDropdown();
  }

  clearSelection(event: MouseEvent) {
    event.stopPropagation();
    this.facade.clearSelection();
    this.selectionChange.emit(this.facade.selectedNodes());
  }

  onLeafSelect(node: TreeNode) {
    this.facade.selectNode(node, this.selectionMode);
    this.selectionChange.emit(this.facade.selectedNodes());
  }

  get filteredNodes(): TreeNode[] {
    return this.facade.getFilteredNodes();
  }

  get search(): string {
    return this.facade.searchQuery();
  }
  set search(value: string) {
    this.facade.updateSearch(value);
  }
}
